import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { load } from '../../../actions/infoServices';

const mapStateToProps = ({ infoServices, user }, { page }) => ({
  permissions: user.permissions || [],
  content: infoServices[page].content,
  isLoaded: infoServices[page].isLoaded,
});
const mapDispatchToProps = dispatch => bindActionCreators({
  loadContent: load,
}, dispatch);

class SharedComponent extends React.Component {
  componentDidMount() {
    const { page, isLoaded, loadContent } = this.props;
    if (!isLoaded) loadContent(page);
  }

  render() {
    const { page, content, isLoaded } = this.props;

    switch (page) {
      case 'faq':
        if (!this.props.permissions.includes('LEARNING_FAQ')) {
          return null;
        }
        break;
      case 'info':
        if (!this.props.permissions.includes('LEARNING_SERVICE_INFORMATION')) {
          return null;
        }
        break;
      case 'terms':
        if (!this.props.permissions.includes('LEARNING_TERMS_CONDITIONS')) {
          return null;
        }
        break;
      default:
        return null;
    }

    return (
      <div className="category_block category_large p-15">{isLoaded
          ? <div dangerouslySetInnerHTML={{ __html: content }} />
          : <i className="fa fa-spin fa-spinner fa-lg mt-3 ml-2" />}
        <div className="clear10" />
      </div>
    );
  }
}

SharedComponent.propTypes = {
  permissions: PropTypes.arrayOf(PropTypes.string).isRequired,
  page: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  loadContent: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(SharedComponent);



// WEBPACK FOOTER //
// ./src/views/_InfoServices/SharedComponent/index.js